document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.menu-list__list-item:has(.mega-menu)').forEach(function (item) {
    var menu = item.querySelector('.mega-menu');
    if (!menu) return;

    // Move to <body> to escape .menu-list__submenu-inner's transform and overflow:hidden
    document.body.appendChild(menu);

    // Background panel — also acts as the hover zone for the dropdown area
    var bg = document.createElement('div');
    bg.style.setProperty('position', 'fixed', 'important');
    bg.style.setProperty('background', 'var(--color-background)', 'important');
    bg.style.setProperty('box-shadow', 'var(--shadow-popover, 0 4px 12px rgba(0,0,0,0.08))', 'important');
    bg.style.setProperty('z-index', '9998', 'important');
    bg.style.display = 'none';
    document.body.appendChild(bg);

    menu.style.setProperty('position', 'fixed', 'important');
    menu.style.setProperty('z-index', '9999', 'important');
    menu.style.setProperty('margin', '0', 'important');
    menu.style.setProperty('transform', 'none', 'important');
    menu.style.display = 'none';

    var hideTimer;

    function showMenu() {
      clearTimeout(hideTimer);
      var rect = item.getBoundingClientRect();
      var header = document.querySelector('#header-component');
      var headerRect = header ? header.getBoundingClientRect() : rect;

      var alignLeft = rect.left;
      var titleSpan = item.querySelector('.menu-list__link-title');
      if (titleSpan) {
        var tNode = null;
        for (var i = 0; i < titleSpan.childNodes.length; i++) {
          if (titleSpan.childNodes[i].nodeType === 3 && titleSpan.childNodes[i].textContent.trim()) {
            tNode = titleSpan.childNodes[i]; break;
          }
        }
        if (tNode) {
          var r = document.createRange();
          r.selectNodeContents(tNode);
          var tBcr = r.getBoundingClientRect();
          if (tBcr.left > 0) alignLeft = tBcr.left;
        }
      }

      menu.style.setProperty('top', rect.bottom + 'px', 'important');
      menu.style.setProperty('left', alignLeft + 'px', 'important');
      menu.style.display = '';

      requestAnimationFrame(function () {
        var menuH = menu.offsetHeight;
        var bgLeft, bgWidth;
        var heroEl = document.querySelector('.hero--custom-width');
        if (heroEl) {
          var rawVal = getComputedStyle(heroEl).getPropertyValue('--hero-content-custom-width').trim();
          var customWidth = parseFloat(rawVal);
          if (!isNaN(customWidth) && customWidth > 0) {
            localStorage.setItem('heroCustomWidth', customWidth);
            bgWidth = Math.min(customWidth, window.innerWidth);
            bgLeft = (window.innerWidth - bgWidth) / 2;
          } else {
            localStorage.removeItem('heroCustomWidth');
            bgLeft = headerRect.left;
            bgWidth = headerRect.width;
          }
        } else {
          var stored = parseFloat(localStorage.getItem('heroCustomWidth'));
          if (!isNaN(stored) && stored > 0) {
            bgWidth = Math.min(stored, window.innerWidth);
            bgLeft = (window.innerWidth - stored) / 2;
          } else {
            bgLeft = headerRect.left;
            bgWidth = headerRect.width;
          }
        }
        bg.style.setProperty('top', rect.bottom + 'px', 'important');
        bg.style.setProperty('left', bgLeft + 'px', 'important');
        bg.style.setProperty('width', bgWidth + 'px', 'important');
        bg.style.setProperty('height', (menuH + 16) + 'px', 'important');
        bg.style.display = '';
      });
    }

    function scheduleHide() {
      hideTimer = setTimeout(function () {
        menu.style.display = 'none';
        bg.style.display = 'none';
      }, 0);
    }

    item.addEventListener('mouseenter', showMenu);
    item.addEventListener('mouseleave', scheduleHide);
    bg.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    bg.addEventListener('mouseleave', scheduleHide);
    menu.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    menu.addEventListener('mouseleave', scheduleHide);
  });
});
